import * as React from 'react';

import type {Props as PageTitleBarProps} from 'shells/layout/page-title-bar';
import {PageTitleBar as PageTitleBarShell} from 'shells/layout/page-title-bar';

import {GlossarySidebarButton} from '../glossary/sidebar/glossary-sidebar-button';

type Props = PageTitleBarProps & {
    glossaryKey?: string;
};

export function PageTitleBar(props: Props) {
    const {glossaryKey, ...restProps} = props;

    return (
        <PageTitleBarShell
            {...restProps}
            glossaryButton={<GlossarySidebarButton glossaryKey={glossaryKey} />}
        />
    );
}
